const toIntOrNull = (value) => {
    if (value === null || value === undefined || value === "") return null
    const parsed = parseInt(value, 10)
    return Number.isNaN(parsed) ? null : parsed
}

// Un champ est « touché » dès que react-hook-form le signale : `true` pour un
// champ simple, un objet de sous-champs pour une valeur structurée (le
// chapitre de programme). Les deux veulent dire « le tuteur a choisi ».
const wasTouched = (dirtyFields, field) => !!dirtyFields?.[field]

/**
 * Ce que « Recommencer » envoie : uniquement ce que le tuteur a réellement
 * choisi.
 *
 * Le formulaire s'ouvre pré-rempli — chapitre détecté par Sam, niveau 2, durée
 * par défaut de la classe. Renvoyer ces valeurs telles quelles fait passer un
 * pré-remplissage pour une décision, avec deux effets que personne n'a
 * demandés :
 *
 *   - un `chapter_id` force le serveur sur la génération à neuf et coupe
 *     `generateSimilarExercises`, le seul chemin qui repart de l'exercice que
 *     l'élève vient de faire. Comme le chapitre est toujours pré-rempli, ce
 *     chemin n'était jamais emprunté depuis cet écran ;
 *   - la durée par défaut du formulaire (5 min pour un collégien) écrase celle
 *     du serveur (10), donc l'élève reçoit un exercice deux fois plus court.
 *
 * Valider sans rien toucher produit donc un payload vide, et le serveur garde
 * son comportement habituel — ce que demande le critère « comportement
 * équivalent au geste actuel ».
 */
export const buildRegeneratePayload = ({
    data,
    dirtyFields,
    useStudyProgram,
}) => {
    const chapterField = useStudyProgram
        ? "studyProgramChapter"
        : "selectedChapter"
    const chapterValue = useStudyProgram
        ? data?.studyProgramChapter?.id
        : data?.selectedChapter

    // On n'émet QUE les clés retenues, plutôt que des `null` qu'il faudrait
    // filtrer ensuite : « ne rien dire » et « dire null » se confondaient, et
    // deux fichiers encodaient la même convention.
    const payload = {}
    const poser = (cle, valeur) => {
        if (valeur !== null) payload[cle] = valeur
    }

    if (wasTouched(dirtyFields, chapterField)) {
        poser("chapter_id", toIntOrNull(chapterValue))
    }
    if (wasTouched(dirtyFields, "selectedLevel")) {
        poser("level", toIntOrNull(data?.selectedLevel))
    }
    if (wasTouched(dirtyFields, "selectedDuration")) {
        poser("duration", toIntOrNull(data?.selectedDuration))
    }
    // Les instructions n'ont aucun pré-remplissage : leur seule présence est
    // déjà une intention.
    poser("instructions", data?.instructions?.trim() || null)

    return payload
}
